import { useEffect } from "react";
import {useLocation} from "react-router-dom";
import {REDIRECT_CONFIG} from "../configs/redirectPage";
import {DASHBOARD} from "../constants/routes";
import {getFlash, setFlash} from "../utils/storage-utils";
import {PREVIOUS_PAGE, REDIRECT_FAILED} from "../constants/app";

const CANNOT_REDIRECT_ERROR = '該当ページに直接アクセスすることは出来ません。';

const useRedirectPage = (pageName, params = '') => {
    const location = useLocation();
    useEffect(() => {
        if (!canRedirectPage(pageName, location.pathname)) {
            setFlash(REDIRECT_FAILED, CANNOT_REDIRECT_ERROR);
            window.location.href = getBackRedirectPage(pageName);
            return;
        }
        const data = {name: pageName, url: location.pathname}
        setFlash(PREVIOUS_PAGE, JSON.stringify(data));
    }, [pageName]);
};

const canRedirectPage = (nextPage, currentUrl) => {
    const previousData = JSON.parse(getFlash(PREVIOUS_PAGE));
    const config = REDIRECT_CONFIG[nextPage];
    if (currentUrl === previousData?.url) return true;
    if (!config || !previousData) return true;

    if ((config?.possible_transition && !config.possible_transition.includes(previousData?.name)) ||
      (config?.except_transition && config.except_transition.includes(previousData?.name))) {
        setFlash(PREVIOUS_PAGE, JSON.stringify(previousData));
        return false;
    }

    return true;
};

const getBackRedirectPage = (nextPage) => {
    const previousData = JSON.parse(getFlash(PREVIOUS_PAGE));
    const oldPage = getFlash('old_page');
    if (oldPage !== true && !canRedirectPage(oldPage)) {
        return DASHBOARD;
    }
    setFlash('old_page', previousData.name);
    const config = REDIRECT_CONFIG[nextPage];
    if (!config) {
        return previousData?.url || DASHBOARD;
    }

    if ((config?.possible_transition && !config.possible_transition.includes(previousData.name)) ||
      (config?.except_transition && config.except_transition.includes(previousData.name))) {
        if (config?.redirect_to) {
            return config?.redirect_to;
        }
        return previousData?.url || DASHBOARD;
    }
};

export default useRedirectPage;
